import { useEffect, useState } from 'react'

const useUTMs = () => {
  const [utms, setUtms] = useState({})

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const utmParams = {
      utm_source: params.get('utm_source') ?? '',
      utm_medium: params.get('utm_medium') ?? '',
      utm_campaign: params.get('utm_campaign') ?? '',
      utm_content: params.get('utm_content') ?? '',
    }
    setUtms(utmParams)
  }, [])

  return utms
}

export default useUTMs
